<template>
  <div class="no-gutters mr-0 pr-0">
    <table class="table-bordered table-evaluation-info">
      <tr>
        <td>
          <div class="mt-3">
            <p class="font-weight-bold mb-0">{{$t('full_proposal_ev.budget__review_title')}}</p>
            <div class="mt-3">
              <radio name="model.budget_review"
                     class="form-check-inline"
                     value="accepted"
                     v-model="EvaluationForm.model.budget_review"
              >
                <label>{{$t('full_proposal_ev.general__info_accepted')}}</label>
              </radio>
            </div>
            <div>
              <radio name="model.budget_review"
                     class="form-check-inline"
                     value="rejected"
                     v-model="EvaluationForm.model.budget_review"
              >
                <label>{{$t('full_proposal_ev.general__info_rejected')}}</label>
              </radio>
            </div>
            <div>
              <radio name="model.budget_review"
                     class="form-check-inline"
                     value="need-more-info"
                     v-model="EvaluationForm.model.budget_review"
              >
                <label>{{$t('full_proposal_ev.general__info_need_more_info')}}</label>
              </radio>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div class="mt-3">
            <p class="font-weight-bold mb-3">{{$t('full_proposal_ev.general__info_grid_by')}}</p>
            <div v-if="EvaluationForm.evaluation && EvaluationForm.evaluation.evaluator">
              <div>{{EvaluationForm.evaluation.evaluator.name}}</div>
              <small>{{EvaluationForm.evaluation.updated_at}}</small>
            </div>
            <div v-else>-</div>
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
  import {EvaluationForm, UserRoles} from "@/services";

  export default {
    data() {
      return {
        EvaluationForm,
        UserRoles,
        loggedUser: {}
      }
    },
    inject: ['validateEvaluation'],
    mounted() {
      let vm = this;
      vm.loggedUser = vm.$store.getters['Auth/loggedUser'];
    }
  }
</script>
